<ngx-spinner class="app-loading-overlay" type="ball-scale-multiple" bdColor="var(--nogosh-page-bg)" [fullScreen]="true" [disableAnimation]="true">
  <app-loading-state titleKey="common.loadingData" [delayMs]="0" [inline]="false"></app-loading-state>
</ngx-spinner>
@if (connection.state$ | async; as connectionState) {
  @if (connectionState !== 'online') {
    <aside class="app-connection-banner" role="status" aria-live="polite">
      <span>{{ (connectionState === 'offline' ? 'common.connectionOffline' : 'common.connectionUnreachable') | translate }}</span>
      <button type="button" class="btn btn-outline-light btn-sm" (click)="connection.check()">{{ 'guestUpgrade.recovery.check' | translate }}</button>
    </aside>
  }
}
@if (showDevBanner) {
  <div class="dev-debug-badges">
    @if (canResetLocalDev) {
      <button
        type="button"
        class="dev-environment-badge dev-environment-reset"
        title="Očisti lokalne web podatke"
        aria-label="Očisti lokalne Footballer web podatke"
        (click)="resetLocalDevelopmentBrowser()">
        {{ devBannerLabel }}
      </button>
    } @else {
      <span class="dev-environment-badge">{{ devBannerLabel }}</span>
    }
    @if (currentPlayerBadgeLabel()) {
      <span class="dev-user-badge">{{ currentPlayerBadgeLabel() }}</span>
    }
  </div>
}

@if (!isPublicGuestRoute() && (authIsAuthenticated$ | async) && guestClaimRecovery) {
  <section class="guest-upgrade-claim-bar guest-claim-choice" [attr.aria-label]="'guestUpgrade.recovery.title' | translate">
    @if (guestClaimDeferred) {
      <button type="button" class="guest-upgrade-claim-action" (click)="guestClaimDeferred = false; retryGuestUpgradeClaim()">{{ 'guestUpgrade.recovery.resume' | translate }}</button>
    } @else {
    <div class="guest-upgrade-claim-copy">
      <strong id="guestClaimChoiceTitle">{{ 'guestUpgrade.recovery.title' | translate }}</strong>
      @if (guestClaimRecovery.eventName) { <span>{{ guestClaimRecovery.eventName }}</span> }
      <span>{{ 'guestUpgrade.recovery.account' | translate }}: {{ currentPlayer?.nickName || currentPlayer?.name }} @if (currentPlayer?.email) { ({{ currentPlayer.email }}) }</span>
      <span>{{ ('guestUpgrade.recovery.' + guestClaimRecovery.reason) | translate }}</span>
      @if (guestUpgradeClaimErrorMsg) { <span role="alert">{{ guestUpgradeClaimErrorMsg }}</span> }
    </div>
    @if (guestUpgradeClaimInProgress) {
      <span class="guest-upgrade-claim-icon" aria-hidden="true">
        <i [class]="('common.loading' | nogoshIcon) + ' nogosh-icon-spin'" aria-hidden="true"></i>
      </span>
      <span class="guest-upgrade-claim-copy">
        <strong>{{ 'guestUpgrade.savingTitle' | translate }}</strong>
        <span>{{ 'guestUpgrade.savingHint' | translate }}</span>
      </span>
    }
    @if (!guestUpgradeClaimInProgress) {
      <div class="guest-claim-choice-actions">
        <button type="button" class="guest-upgrade-claim-action guest-claim-secondary" (click)="deferGuestClaim()">{{ 'guestUpgrade.recovery.later' | translate }}</button>
        <button type="button" class="guest-upgrade-claim-action guest-claim-secondary" (click)="forgetGuestClaim()">{{ 'guestUpgrade.recovery.forget' | translate }}</button>
        @if (guestClaimRecovery.canClaim) {
          <button type="button" class="guest-upgrade-claim-action" (click)="confirmGuestClaim()">{{ 'guestUpgrade.recovery.connect' | translate }}</button>
        } @else if (guestClaimRecovery.reason === 'connection' || guestClaimRecovery.reason === 'busy') {
          <button type="button" class="guest-upgrade-claim-action" (click)="retryGuestUpgradeClaim()">{{ 'guestUpgrade.recovery.check' | translate }}</button>
        }
      </div>
    }
    }
  </section>
}

@if ((isPublicGuestRoute() && !isPublicProfileRoute()) || (isPublicProfileRoute() && (authIsLoading$ | async)===false && (authRedirectInProgress$ | async)===false && (authIsAuthenticated$ | async)===false) || (isClaimRoute() && (authRedirectInProgress$ | async)===false && (authIsAuthenticated$ | async)===false)) {
  @if (isPublicRouteActivated()) {
    <router-outlet></router-outlet>
  }
}

@if (isAppShellRoute() && ((authIsLoading$ | async) || (authRedirectInProgress$ | async))) {
  <app-loading-state titleKey="common.loadingApp" subtitleKey="common.loadingHint" [page]="true" [inline]="false" [delayMs]="0"></app-loading-state>
}

@if (!isClaimRoute() && !isPublicProfileRoute() && !isPublicGuestRoute() && (authIsLoading$ | async)===false && (authRedirectInProgress$ | async)===false && (authIsAuthenticated$ | async)===false) {
  @if (showLandingLanguageSelection) {
    <app-screen-shell [contentClass]="'public-entry-shell login-language-landing'" layout="public-entry" variant="public" [showHeader]="false">
      <section class="login-language-panel">
        <img class="login-language-logo" src="../assets/images/footballer-zone-logo-transparent.png" alt="Footballer Zone"/>
        <h1 id="loginLanguageTitle">{{ 'splashLanguage.dropdownTitle' | translate }}</h1>

        <div class="login-language-options" role="radiogroup" [attr.aria-label]="'splashLanguage.dropdownTitle' | translate">
          <button
            type="button"
            class="login-language-option"
            role="radio"
            [class.selected]="isSelectedLandingLanguage('en')"
            [attr.aria-checked]="isSelectedLandingLanguage('en')"
            (click)="selectLandingLanguage('en')">
            <span class="login-language-option-label">
              <span class="login-language-flag" aria-hidden="true">🇬🇧</span>
              <span>{{ 'languages.en' | translate }}</span>
            </span>
            @if (isSelectedLandingLanguage('en')) {
              <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
            }
          </button>
          <button
            type="button"
            class="login-language-option"
            role="radio"
            [class.selected]="isSelectedLandingLanguage('hr')"
            [attr.aria-checked]="isSelectedLandingLanguage('hr')"
            (click)="selectLandingLanguage('hr')">
            <span class="login-language-option-label">
              <span class="login-language-flag" aria-hidden="true">🇭🇷</span>
              <span>{{ 'languages.hr' | translate }}</span>
            </span>
            @if (isSelectedLandingLanguage('hr')) {
              <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
            }
          </button>
        </div>
      </section>
    </app-screen-shell>
  } @else {
  <app-screen-shell [contentClass]="'public-entry-shell login-landing'" layout="public-entry" variant="public" [showHeader]="false">
    <section class="login-landing-panel">
      <img class="login-logo" src="../assets/images/footballer-zone-logo-transparent.png" alt="Footballer Zone"/>
      <h1>{{ 'splashTeam.title' | translate }}</h1>
      <p class="login-team-description">{{ 'splashTeam.description' | translate }}</p>
      @if (guestLandingError) {
        <p class="login-error" role="alert">{{guestLandingError}}</p>
      }
      <button type="button" class="btn btn-primary login-create-button" (click)="createGuestMatch()">{{ guestLandingPrimaryLabel() }}</button>
      <p class="login-account-link">
        {{ 'landing.alreadyHaveProfile' | translate }}
        <button type="button" class="btn btn-link" (click)="login()">{{ 'auth.login' | translate }}</button>
      </p>
      <p class="login-signup-link">
        {{ 'landing.readyToCreateProfile' | translate }}
        <button type="button" class="btn btn-link" (click)="signup()">{{ 'landing.createProfile' | translate }}</button>
      </p>
      <div class="login-app-downloads" [attr.aria-label]="'landing.downloadApp' | translate">
        @if (mobilePlatform) {
          <a class="login-app-open-link" [href]="mobileAppUrl">
            {{ 'publicInvite.appDownload.openInApp' | translate }}
          </a>
        }
        <span class="login-app-downloads-label">{{ 'landing.downloadApp' | translate }}</span>
        <div class="login-app-download-actions">
          @if (showAndroidAppLink && androidAppUrl) {
            <a
              class="login-app-download-link"
              [href]="androidAppUrl"
              target="_blank"
              rel="noopener noreferrer">
              <i [class]="'auth.android' | nogoshIcon" aria-hidden="true"></i>
              <span>Android</span>
            </a>
          }
          @if (showIosAppLink && iosAppUrl) {
            <a
              class="login-app-download-link"
              [href]="iosAppUrl"
              target="_blank"
              rel="noopener noreferrer">
              <i [class]="'auth.apple' | nogoshIcon" aria-hidden="true"></i>
              <span>iPhone</span>
            </a>
          }
        </div>
      </div>
      <button
        type="button"
        class="login-language-back"
        [attr.aria-label]="'publicInvite.changeLanguage' | translate"
        [title]="'publicInvite.changeLanguage' | translate"
        (click)="showLandingLanguageChooser()">
        <i [class]="'common.chevronLeft' | nogoshIcon" aria-hidden="true"></i>
        <span>{{ 'common.back' | translate }}</span>
      </button>
    </section>
  </app-screen-shell>
  }
}

@if (isAppShellRoute() && (authIsLoading$ | async)===false && (bootstrapReady$ | async)===false && (authIsAuthenticated$ | async)) {
  <app-loading-state titleKey="common.loadingData" subtitleKey="common.loadingHint" [page]="true" [inline]="false" [delayMs]="0"></app-loading-state>
}

@if (isAppShellRoute() && (bootstrapReady$ | async) && authMethodMismatch && (authIsAuthenticated$ | async)) {
  <app-screen-shell [contentClass]="'public-entry-shell auth-resolution-page'" layout="public-entry" variant="guest" [showHeader]="false">
    <section class="auth-resolution-panel">
      <img class="auth-resolution-logo" src="../assets/images/footballer-zone-logo-transparent.png" alt="Footballer Zone"/>
      <div class="auth-resolution-icon" aria-hidden="true">
        <i [class]="'player.profile' | nogoshIcon" aria-hidden="true"></i>
      </div>
      <h1 id="authMethodMismatchTitle">{{ 'auth.methodMismatchTitle' | translate }}</h1>
      <p class="auth-resolution-summary">
        {{ 'auth.methodMismatchSummary' | translate: { existingAuth: authMethodMismatch.existingAuth, attemptedWith: authMethodMismatch.attemptedWith } }}
      </p>
      <div class="auth-resolution-detail" role="status">
        <span>
          {{ 'auth.methodMismatchExisting' | translate: { existingAuth: authMethodMismatch.existingAuth } }}
        </span>
        <span>
          {{ 'auth.methodMismatchAttempted' | translate: { attemptedWith: authMethodMismatch.attemptedWith } }}
        </span>
      </div>
      <div class="auth-resolution-actions">
        <button type="button" class="auth-resolution-primary" (click)="restartLoginAfterMethodMismatch()">
          {{ 'auth.methodMismatchSwitchLogin' | translate: { existingAuth: authMethodMismatch.existingAuth } }}
        </button>
        <button type="button" class="auth-resolution-secondary" (click)="continueAsGuestAfterMethodMismatch()">
          {{ 'auth.methodMismatchContinueGuest' | translate }}
        </button>
      </div>
      <p class="auth-resolution-help">{{ 'auth.methodMismatchHelp' | translate }}</p>
    </section>
  </app-screen-shell>
}

@if (isAppShellRoute() && (bootstrapReady$ | async) && !authMethodMismatch && bootstrapErrorKey && (authIsAuthenticated$ | async)) {
  <app-screen-shell [contentClass]="'container py-5 text-center'" [showHeader]="false">
    <p class="alert alert-danger" role="alert">{{ bootstrapErrorKey | translate }}</p>
    <button type="button" class="btn btn-primary" (click)="retryBootstrap()">{{ 'common.tryAgain' | translate }}</button>
  </app-screen-shell>
}

@if (isAppShellRoute() && (bootstrapReady$ | async) && !bootstrapErrorKey && currentPlayer && (authIsAuthenticated$ | async)) {
  <div class="authenticated-app-shell">
    <app-nav-bar></app-nav-bar>
    <router-outlet></router-outlet>
    @if (showFooter()) {
      <app-footer></app-footer>
    }
  </div>
}

<app-global-dialog></app-global-dialog>
